import React, { Component } from 'react';
import PropTypes from 'prop-types';
import parseObjectTypeName from '../helpers/parseObjectTypeName';

class ToggleSet extends Component {
  render() {
    const elmClassName = (name) => {
      return this.props.componentName
        ? `${this.props.componentName}-${name}`
        : null;
    };

    return (
      <form
        className={`${elmClassName('container')} ${
          this.props.theme
            ? this.props.componentName + '-' + this.props.theme
            : ''
        } `}
        onClick={this.props.onSelectionChange}
      >
        <div className={elmClassName('wrapper')}>
          {this.props.switches &&
            this.props.switches.map((item, index) => {
              return (
                <label className={elmClassName('radio')} key={index}>
                  <input
                    name="radio"
                    type="radio"
                    value={item.value}
                    defaultChecked={item.checked}
                  />
                  <span className={elmClassName('radioindicator')}></span>
                  <span className={elmClassName('radiolabel')}>
                    {parseObjectTypeName(item.label)}
                  </span>
                </label>
              );
            })}
        </div>
      </form>
    );
  }
}
export default ToggleSet;

ToggleSet.propTypes = {
  componentName: PropTypes.string,
  theme: PropTypes.string,
};
ToggleSet.defaultProps = {
  componentName: 'control',
  theme: null,
};



// WEBPACK FOOTER //
// ./src/js/components/ToggleSet.js